import React, { Fragment } from "react";
import { Message } from "../components/thankYou";
import { PageBanner } from "../components/common";

const ProductView = () => {
  return (
    <Fragment>
      <PageBanner
        // pageTitle="About Us"
        homePageUrl="/"
        homePageText="Home"
        activePageText="Thank You"
      />
      <Message />
    </Fragment>
  );
};

export default ProductView;
